import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Approves or rejects a Pending Profit Distribution
// payload: { id, action: "approve" | "reject", userLoggedID }
export const approveProfitDistribution = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/profit_distribution/approveProfitDistribution`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
